export const NETWORKS = Object.freeze({
  AURORA: 1313161554,
});

export const RPC_URL = Object.freeze({
  [NETWORKS.AURORA]: "https://mainnet.aurora.dev/",
});

export const DEFAULT_NETWORK = NETWORKS.AURORA;
